import { TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React, { ChangeEvent, useContext, useState } from 'react';
import endpoints from '../constants/endpoints';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import SelectMultiple from './SelectMultiple';
import useApiRequest from '../services/apiRequest';
import useFetch from '../hooks/useFetch';

const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

type Props = {
    overprice?: boolean
}

function PeriodSelector({ overprice = false }: Props) {
    const { typedFilters, setTypedFilters } = useContext(GlobalStateContext);
    const { typedFiltersOverprice, setTypedFiltersOverprice } = useContext(GlobalStateContext);
    const { data, error, loading } = useFetch(endpoints.LIST_YEARS, "", "GET")


    const handleChange = (key: string, value: string) => {
        if (overprice) {
            setTypedFiltersOverprice({
                ...typedFiltersOverprice,
                [key]: value
            });
        } else {
            setTypedFilters({
                ...typedFilters,
                [key]: value
            });
        }
    };

    const setAfter = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { target } = event;
        handleChange(target.name, target.value);
    };

    const setBefore = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { target } = event;
        handleChange(target.name, target.value);
    };

    const changePeriodOrExercise = (isPeriod: boolean) => {
        if (overprice) {
            if (isPeriod) {
                setTypedFiltersOverprice({ ...typedFiltersOverprice, year: [], month: [], isPeriod });
            } else {
                setTypedFiltersOverprice({ ...typedFiltersOverprice, before: undefined, after: undefined, isPeriod });
            }
        } else {
            if (isPeriod) {
                setTypedFilters({ ...typedFilters, year: [], month: [], isPeriod });
            } else {
                setTypedFilters({ ...typedFilters, before: undefined, after: undefined, isPeriod });
            }
        }
    };

    return (
        <>
            <div className="w-[155px] mr-2">
                <ToggleButtonGroup
                    value={(overprice ? typedFiltersOverprice.isPeriod : typedFilters.isPeriod) ? "period" : "exercise"}
                    exclusive
                    onChange={(event, newValue) => changePeriodOrExercise(newValue === "period")}
                    size="small"
                >
                    <ToggleButton value="period">Período</ToggleButton>
                    <ToggleButton value="exercise">Exercício</ToggleButton>
                </ToggleButtonGroup>
            </div>

            {(overprice ? typedFiltersOverprice.isPeriod : typedFilters.isPeriod) ? (
                <>
                    <div className="flex-1 flex gap-2 items-center">
                        <div>de</div>
                        <div className="flex-1">
                            <TextField
                                onChange={setAfter}
                                value={overprice ? typedFiltersOverprice.after : typedFilters.after}
                                name="after"
                                className='w-full'
                                type="date"
                                variant="outlined"
                            />
                        </div>
                    </div>
                    <div className="flex-1 flex gap-2 items-center">
                        <div>até</div>
                        <div className="flex-1">
                            <TextField
                                onChange={setBefore}
                                value={overprice ? typedFiltersOverprice.before : typedFilters.before}
                                name="before"
                                className='w-full'
                                type="date"
                                variant="outlined"
                            />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="flex-1">
                        <SelectMultiple options={data || []} label="Ano(s)" filterKey='year' overprice={overprice}/>
                    </div>
                    <div className="flex-1">
                        <SelectMultiple options={months} label="Meses(s)" filterKey='month' overprice={overprice}/>
                    </div>
                </>
            )}
        </>
    );
}

export default PeriodSelector;
